import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import InputField from "../../jsx/components/fields/inputField";
import SelectInputCompetency from "../../jsx/components/fields/selectInputCompetency";
import { numberValidation } from "../../functions/validations";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { promocodeByIdApi } from "../../service/api/promocode/promocodeById";
import SelectPromocode from "../../jsx/components/fields/selectPromocode";
import { addOrUpdatePromocodeApi } from "../../service/api/promocode/addOrUpdatePromocode";
import InputFieldPercentDollar from "../../jsx/components/fields/inputFieldPercentDollar";
import SearchableSelect from "../../jsx/components/fields/serchableSelect";
import { registeredUser } from "../../service/api/user/registeredUser";

const AddOrUpdatePromocode = ({
  promocodeModalStatus,
  handleClose,
  modalType,
  promocodeId,
  promocodeTypeList,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [promocodeName, setPromocodeName] = useState("");
  const [isPromocodeNameError, setIsPromocodeNameError] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [isExpiryDateError, setIsExpiryDateError] = useState(false);
  const [totalAmountCents, setTotalAmountCents] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [isTotalAmountError, setIsTotalAmountError] = useState(false);
  const [customerDiscount, setCustomerDiscount] = useState("");
  const [isCustomerDiscountError, setIsCustomerDiscountError] = useState(false);
  const [customerDiscountDollar, setCustomerDiscountDollar] = useState("");
  const [proDeduction, setProDeduction] = useState("");
  const [isProDeductionError, setIsProDeductionError] = useState(false);
  const [proDeductionDollar, setProDeductionDollar] = useState("");
  const [promocodeType, setPromocodeType] = useState("");
  const [isPromocodeTypeError, setIsPromocodeTypeError] = useState(false);
  const [promocodeTypesList, setPromocodeTypesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFrequencyExpiryError, setIsFrequencyExpiryError] = useState(false);
  const [promocodeTypeJson, setPromoTypeJson] = useState("");
  const [modeDollarForCustDiscount, setModeDollarForCustDiscount] = useState(false);
  const [modeDollarForProDeduction, setModeDollarForProDeduction] = useState(false);
  const [promoTypeId, setPromoTypeId] = useState();
  const [efficientCustomerDiscount, setEfficientCustomerDiscount] = useState("");
  const [effectiveAmountToCharge, setEffectiveAmountToCharge] = useState("");
  const [effectiveProTotalEarning, setEffectiveProTotalEarning] = useState("");
  const [searchValue,setSearchValue] = useState("")
  const [userId,setUserId] = useState("")
const[elements,setElements] = useState([])
  function onLoadData() {

  if(searchValue.length > 2 || searchValue.length == 0){
    setElements([])

    const data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id"));
    data.append("page_index", 1);
    data.append("page_size", 10000);
    data.append("sorting_order", "ASC");
    data.append("sorting_column_name", "");
    data.append("search_area", searchValue);
    data.append("role_id_int",1)

    dispatch(
      registeredUser(data, (res) => {
        
        setElements(res.data.data);
       
      }, (err) => {
      
      })
    );

  }
    
  }
  useEffect(()=>{
    onLoadData()
  },[searchValue])
  useEffect(() => {
    if (modalType !== "add") {
      const data = {
        promo_code_id_ids: promocodeId,
      };

      dispatch(promocodeByIdApi(data, (res) => {
        setPromocodeTypesList(res.data.promo_code_types);
        setPromocodeDetails(res.data.data);
      }));
    } else {
      setPromoTypeJson("");
    }
  }, [modalType, promocodeId, dispatch]);

  function setPromocodeDetails(promocode) {
    setPromocodeName(promocode.promo_code_str || "");
    setFrequency(promocode.frequency_int?.toString() || "");
    setExpiryDate(
      promocode.expiry_date_dtm
        ? new Date(promocode.expiry_date_dtm * 1000).toISOString().split("T")[0]
        : ""
    );
    const totalAmountInDollars = promocode.fixed_amount_in_cents_float / 100;
    setTotalAmountCents(promocode.fixed_amount_in_cents_float);
    setTotalAmount(totalAmountInDollars);
    setCustomerDiscount(
      promocode.charge_discount_percentage_float?.toString() || ""
    );
    setCustomerDiscountDollar(
      (promocode.charge_discount_percentage_float / 100) * totalAmountInDollars || ""
    );
    setProDeduction(promocode.pro_percentage_float?.toString() || "");
    setProDeductionDollar(
      (promocode.pro_percentage_float / 100) * totalAmountInDollars || ""
    );
    setPromocodeType(promocode.promo_code_type_str || "");
    setPromoTypeId(promocode.type_id_lng);
    setPromoTypeJson(promocode.selected_promo_code);
  }

  function handlePromocodeName(e) {
    setPromocodeName(e.target.value);
    setIsPromocodeNameError(false);
  }

  function handlePromocodeType(selectedOption) {
    setPromoTypeJson(selectedOption);
    setPromocodeType(selectedOption.type_name_chr);
    const totalAmountInDollars = selectedOption.total_amount_in_cents_float / 100;
    setTotalAmountCents(selectedOption.total_amount_in_cents_float);
    setTotalAmount(totalAmountInDollars);
    setPromoTypeId(selectedOption.type_id_ids);
    setIsPromocodeTypeError(false);
  }

  function handleTotalAmount(e) {
    const value = e.target.value;
    if (numberValidation(value)) {
      const totalAmountInDollars = value / 100;
      setTotalAmountCents(value);
      setTotalAmount(totalAmountInDollars);
      setIsTotalAmountError(totalAmountInDollars === 0);
    }
  }

  function handleCustomerDiscount(e, modeDollar) {
    const value = e.target.value;

    if (!modeDollar) {
      if (numberValidation(value) && value <= 100) {
        setCustomerDiscount(value);
        setIsCustomerDiscountError(value === "0");

        const dollarValue = (value / 100) * totalAmount;
        setCustomerDiscountDollar(dollarValue);
      }
    } else {
      if (numberValidation(value) && value <= totalAmount) {
        setCustomerDiscountDollar(value);
        setIsCustomerDiscountError(value === "0");

        const percentageValue = (value / totalAmount) * 100;
        setCustomerDiscount(percentageValue);
      }
    }
  }

  function handleProDeduction(e, modeDollar) {
    const value = e.target.value;

    if (!modeDollar) {
      if (numberValidation(value) && value <= 100) {
        if (value > 80) {
          setIsProDeductionError(true);
          setProDeduction(""); // Reset if invalid
          setProDeductionDollar(""); // Reset the dollar value
        } else {
          setProDeduction(value);
          setIsProDeductionError(value === "0");

          const dollarValue = (value / 100) * totalAmount;
          setProDeductionDollar(dollarValue);
        }
      }
    } else {
      const percentageValue = (value / totalAmount) * 100;
      if (numberValidation(value) && percentageValue <= 80) {
        setProDeductionDollar(value);
        setIsProDeductionError(value === "0");

        setProDeduction(percentageValue);
      } else {
        setIsProDeductionError(true);
        setProDeduction(""); // Reset if invalid
        setProDeductionDollar(""); // Reset the dollar value
      }
    }
  }

  function handlePromocodeSubmit() {
    // Reset all error states
    setIsPromocodeNameError(!promocodeName);
    setIsPromocodeTypeError(!promocodeType);
    setIsTotalAmountError(!totalAmount || totalAmount === "0");
    setIsCustomerDiscountError(!customerDiscount || customerDiscount === "0");
    setIsProDeductionError(!proDeduction || proDeduction === "0");

    const isFormValid =
      promocodeName &&
      promocodeType &&
      totalAmount &&
      totalAmount !== "0" &&
      customerDiscount &&
      customerDiscount !== "0" &&
      proDeduction &&
      proDeduction !== "0" &&
      !isProDeductionError;

    if (isFormValid) {
      if (!frequency && !expiryDate) {
        setIsFrequencyExpiryError(true);
      } else {
        setIsFrequencyExpiryError(false);
        setIsLoading(true);

        const formData = new FormData();
        formData.append("promo_code_id_ids", promocodeId || "");
        formData.append("promo_code_str", promocodeName);
        formData.append("promo_code_type_str", promocodeType);
        formData.append("charge_percentage_float", customerDiscount);
        formData.append("charge_amount_float", efficientCustomerDiscount);
        formData.append("pro_percentage_float", proDeduction);
        formData.append("pro_amount_float", effectiveProTotalEarning);
        formData.append("created_for_chr", userId);
        frequency !== "" && formData.append("frequency_int", frequency);
        formData.append("type_id_ids", promoTypeId);
        expiryDate && formData.append(
          "unix_expiry_date_dtm",
          expiryDate ? Math.floor(new Date(expiryDate).getTime() / 1000) : null
        );

        dispatch(
          addOrUpdatePromocodeApi(formData, (response) => {
            setIsLoading(false);
            handleClose("load");
          }, () => { setIsLoading(false); })
        );
      }
    }
  }

  useEffect(() => {
    const totalAmountNumber = parseFloat(totalAmount);
    const customerDiscountDollarNumber = parseFloat(customerDiscountDollar);
    const calculatedEfficientCustomerDiscount = totalAmountNumber - customerDiscountDollarNumber;
    
    if (!isNaN(calculatedEfficientCustomerDiscount)) {
      setEfficientCustomerDiscount(calculatedEfficientCustomerDiscount); // Keep as number
    } else {
      setEfficientCustomerDiscount(0); // Set as number 0
    }
  }, [totalAmount, customerDiscountDollar]);
  
  useEffect(() => {
    const totalAmountNumber = parseFloat(totalAmount);
    const proDeductionDollarNumber = parseFloat(proDeductionDollar);
    
    if (!isNaN(totalAmountNumber) && !isNaN(proDeductionDollarNumber)) {
      const twentyPercentOfTotalAmount = totalAmountNumber * 0.2;
      let calculatedEffectiveProTotalEarning = totalAmountNumber - twentyPercentOfTotalAmount - proDeductionDollarNumber;
      
      if (calculatedEffectiveProTotalEarning < 0) {
        calculatedEffectiveProTotalEarning = 0;
      }

      setEffectiveProTotalEarning(calculatedEffectiveProTotalEarning.toFixed(2)); // Keep as number
    } else {
      setEffectiveProTotalEarning(0);
    }
  }, [totalAmount, proDeductionDollar]);

  return (
    <>
      <Modal className="fade" size={"md"} show={promocodeModalStatus} centered>
        <Modal.Body>
          <div className="mx-0 row text-black mb-4">
            <div className="col-12 d-flex fs-4 justify-content-end px-0">
              <span
                onClick={() => {
                  handleClose("close");
                }}
                className="cursor-pointer"
              >
                <i className="bi bi-x-lg"></i>
              </span>
            </div>
            <div className="col-12 font-w600 fs-3 px-0 text-center">
              <span>
                {modalType === "edit" && "Update Promocode Details"}
                {modalType === "add" && "Add Promocode Details"}
                {modalType === "view" && "Promocode Details"}
              </span>
            </div>
          </div>

          <div>
            <div className="mt-2" style={{ borderRadius: "5px" }}>
              <InputField
                labelName={"Promocode Name"}
                placeholderName={"Promocode Name"}
                value={promocodeName}
                onChange={handlePromocodeName}
                onBlur={() => setIsPromocodeNameError(!promocodeName)}
                errorOccured={isPromocodeNameError}
                errorMeesage={"Please enter promocode name"}
                disabled={modalType === "view"}
              />
              <SearchableSelect  userArray={elements} handleChangeSearchValue={(e)=>{setSearchValue(e)}}handleChangeCode={(e)=>{setUserId(e)}} />

              <div className="row justify-content-between">
                <div className="col-md-6 px-0 pe-md-2">
                  <SelectPromocode
                    labelName={"Promocode Type"}
                    defaultValue={promocodeTypeJson}
                    disabled={modalType === "view"}
                    options={promocodeTypeList}
                    onChange={handlePromocodeType}
                    onBlur={() => setIsPromocodeTypeError(!promocodeType)}
                    errorOccured={isPromocodeTypeError}
                    errorMessage={"Please select promocode type"}
                  />
                </div>
                <div className="col-md-6 px-0 ps-md-2">
                  <InputField
                    labelName={"Frequency"}
                    placeholderName={"Frequency"}
                    value={frequency}
                    onChange={(e) =>
                      modalType !== "view" &&
                      numberValidation(e.target.value) &&
                      setFrequency(e.target.value)
                    }
                    disabled={modalType === "view"}
                  />
                </div>
              </div>

              <InputField
                labelName={"Total amount"}
                placeholderName={"Total amount"}
                value={totalAmount}
                onChange={handleTotalAmount}
                onBlur={() => setIsTotalAmountError(!totalAmount || totalAmount === "0")}
                errorOccured={false}
                errorMeesage={
                  totalAmount === ""
                    ? "Please enter total amount"
                    : "Total amount cannot be zero"
                }
                disabled={true}
                appendText="$"
                autoActivated={true}
              />

              <InputFieldPercentDollar
                labelName={"Customer Discount"}
                placeholderName={"Customer Discount"}
                value={customerDiscount}
                onChange={handleCustomerDiscount}
                onBlur={() =>
                  setIsCustomerDiscountError(!customerDiscount || customerDiscount === "0")
                }
                errorOccured={isCustomerDiscountError}
                errorMeesage={
                  customerDiscount === ""
                    ? "Please enter customer discount"
                    : "Customer discount cannot be zero"
                }
                disabled={modalType === "view"}
                modeDollar={modeDollarForCustDiscount}
                handleModeDollar={(e) => setModeDollarForCustDiscount(e !== "%")}
                valueDollar={customerDiscountDollar}
              />

              <InputFieldPercentDollar
                labelName={"Pro Deduction"}
                placeholderName={"Pro Deduction"}
                value={proDeduction}
                onChange={handleProDeduction}
                onBlur={() =>
                  setIsProDeductionError(!proDeduction || proDeduction === "0")
                }
                errorOccured={isProDeductionError}
                errorMeesage={
                  proDeduction === ""
                    ? "Please enter pro deduction"
                    : "Pro deduction cannot be zero"
                }
                disabled={modalType === "view"}
                modeDollar={modeDollarForProDeduction}
                handleModeDollar={(e) => setModeDollarForProDeduction(e !== "%")}
                valueDollar={proDeductionDollar}
                autoActivated={true}
              />

              <InputField
                labelName={"Effective Customer Charge"}
                placeholderName={"Efficient Customer Discount"}
                value={efficientCustomerDiscount}
                disabled={true}
                appendText="$"
                autoActivated={true}
              />

              <InputField
                labelName={"Effective Pro Total Earning"}
                placeholderName={"Effective Pro Total Earning"}
                value={effectiveProTotalEarning}
                disabled={true}
                appendText="$"
                autoActivated={true}
              />

              <InputField
                labelName={"Expiry Date"}
                type="date"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e.target.value)}
                onBlur={() => setIsExpiryDateError(!expiryDate)}
                errorOccured={isExpiryDateError}
                errorMeesage={"Please enter expiry date"}
                disabled={modalType === "view"}
                autoActivated={true}
              />
            </div>
          </div>
          {isFrequencyExpiryError && (
            <div className="text-danger mt-2">
              Frequency and Expiry Date should not both be empty.
            </div>
          )}
        </Modal.Body>
        {modalType !== "view" && (
          <Modal.Footer>
            <PrimaryButton
              buttonName={modalType === "edit" ? "Update" : "Add"}
              onClick={handlePromocodeSubmit}
              isLoading={isLoading}
              loadingMessage={modalType === "edit" ? "Updating" : "Adding"}
            />
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default AddOrUpdatePromocode;
